import localStorage from "src/utils/local-storage";

const {
  can_publish,
  can_edit_publish,
  can_takedown,
  publishCategories,
  can_publish_video_post,
  can_publish_podcast_post,
  can_publish_short_post,
} = localStorage.get("_user");

const compareArray = (arr1, arr2) => {
  const ids1 = arr1.map((item) => item._id);
  const ids2 = arr2.map((item) => item._id);
  let flag = false;

  ids1.forEach((id) => {
    if (ids2.includes(id)) {
      flag = true;
    }
  });

  return flag;
};

const checkPermission = (post, permission) => {
  const { categories = [] } = post;

  if (permission) {
    return compareArray(categories, publishCategories);
  }

  return false;
};

const checkPermissionPostType = (post, permission) => {
  if (permission) {
    return true;
  }
  
  return false;
}

export const checkCanPublish = (post) => {
  switch(post.editor_type){
    case 'video':
      return checkPermissionPostType(post, can_publish_video_post);
      break;
    case 'podcast':
      return checkPermissionPostType(post, can_publish_podcast_post);
      break;
    case 'short':
      return checkPermissionPostType(post, can_publish_short_post);
      break;
    default:
      return checkPermission(post, can_publish);
      break;
  }
};

export const checkCanEditPublish = (post) => {
  switch(post.editor_type){
    case 'video':
      return checkPermissionPostType(post, can_publish_video_post);
      break;
    case 'podcast':
      return checkPermissionPostType(post, can_publish_podcast_post);
      break;
    case 'short':
      return checkPermissionPostType(post, can_publish_short_post);
      break;
    default:
      return checkPermission(post, can_edit_publish);
      break;
  }
};

export const checkCanTakedown = (post) => {
  switch(post.editor_type){
    case 'video':
      return checkPermissionPostType(post, can_publish_video_post);
      break;
    case 'podcast':
      return checkPermissionPostType(post, can_publish_podcast_post);
      break;
    case 'short':
      return checkPermissionPostType(post, can_publish_short_post);
      break;
    default:
      return checkPermission(post, can_takedown);
      break;
  }
};
